import React, { useCallback, useMemo, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { createStyledIndicatorButton } from "../../../common/StyledComponents/SideBarComponents";
import infoIcon from "../../../assets/images/chats/infoIcon.svg";
import {
  AccountLevelArkchatPermission,
  GroupLevelArkchatPermission,
  InviteType,
  MessageType,
} from "../../../utils/constant";
import useAppSelectors from "../../../customHooks/useAppSelectors";
import { useTranslation } from "react-i18next";
import {
  fontSizeSchemes,
  crossIcon,
  crossIconDiv,
} from "../../../assets/commonFunction";
import AlertPopUp from "../../../common/AlertPopUp";
import PersonIcon from "../../../assets/images/chats/person.svg";
import PersonIconDisabled from "../../../assets/images/chats/personDisable.svg";
import SelectCheckBox from "../../../assets/images/chats/selectcheckbox.svg";
import session from "../../../utils/helper";
import useStableCallbacks from "../../../customHooks/useStableCallbacks";
import useProgressiveList from "../../../customHooks/useProgressiveList";

const NameBadge = createStyledIndicatorButton("#E3E1E1");

const checkboxIconStyle = {
  width: 25,
  height: 25,
  display: "block",
};
const memberIndicatorStyle = {
  width: "25px",
  height: "25px",
  minWidth: "25px",
  minHeight: "25px",
  color: "#183243",
  padding: 0,
  overflow: "hidden",
};
const classes = {
  drawerBody: {
    minWidth: "31.25rem",
    maxWidth: "31.25rem",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    height: "100%",
  },
  header: {
    backgroundColor: "#F9F8F8",
    color: "#0000",
    padding: "7px 8px",
  },
  iconDiv: crossIconDiv,
  iconn: crossIcon,
  radiogp: {
    display: "block",
  },
};

// One member in the picker. Memoized: ticking one member re-renders only
// that row (each tick re-rendered every row; in a big group, every member).
const InternalMemberRow = React.memo(function InternalMemberRow({
  memberData,
  checked,
  disabled,
  isApprovalSelf,
  buttonName,
  buttonDisabled,
  onToggle,
  onTodo,
  onInfo,
}) {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      spacing={1}
      padding={"0rem 0.7rem 0rem 2rem"}
    >
      <FormControlLabel
        sx={{
          ".MuiFormControlLabel-label": {
            fontSize: "0.78rem !important",
            color: "#000000",
          },
        }}
        control={
          <Checkbox
            sx={{
              "& .MuiSvgIcon-root": {
                fontSize: 25,
                color: "#183243",
              },
            }}
            disabled={disabled}
            onChange={(e) => onToggle(e, memberData)}
            checked={checked}
            checkedIcon={
              <img
                style={checkboxIconStyle}
                src={SelectCheckBox}
                alt="selected"
              />
            }
            icon={
              <NameBadge
                sx={{
                  ...memberIndicatorStyle,
                  color: "#183243",
                  padding: memberData?.userInfo?.profileImgUrl
                    ? "0rem"
                    : "0rem",
                  }}
                size="small"
                variant="contained"
              >
                {memberData?.userInfo?.profileImgUrl ? (
                  <img
                    style={{ width: "100%", height: "100%" }}
                    src={memberData?.userInfo?.profileImgUrl}
                    alt={memberData?.userInfo?.firstName}
                  />
                ) : (
                  <img
                    src={
                      isApprovalSelf
                        ? PersonIconDisabled
                        : PersonIcon
                    }
                    alt="all"
                  />
                  // <Typography
                  //   color={"#183243"}
                  //   fontSize={"0.75rem"}
                  // >
                  //   {memberData?.userInfo?.firstName &&
                  //     memberData?.userInfo?.firstName[0]}
                  // </Typography>
                )}
              </NameBadge>
            }
          />
        }
        label={
          <Box
            display={"flex"}
            alignItems={"center"}
            gap={"0.15rem"}
          >
            <Typography
              title={`${memberData?.userInfo?.firstName} ${memberData?.userInfo?.lastName}`}
              maxWidth={"20rem"}
              overflow={"hidden"}
              textOverflow={"ellipsis"}
              whiteSpace={"nowrap"}
              fontSize={fontSizeSchemes.font14}
              fontWeight={400}
            >
              {`${memberData?.userInfo?.firstName} ${memberData?.userInfo?.lastName}`}
              <>,</>
            </Typography>
            {(() => {
              if (
                memberData?.permission ===
                  AccountLevelArkchatPermission?.ADMIN &&
                memberData?.inviteType ===
                  InviteType?.ownerInviteType
              ) {
                return (
                  <Typography fontSize={"0.7rem"}>
                    Owner
                  </Typography>
                );
              } else if (
                memberData?.permission ===
                  AccountLevelArkchatPermission?.ADMIN &&
                memberData?.inviteType === InviteType?.internal
              ) {
                return (
                  <Typography fontSize={"0.7rem"}>
                    Admin
                  </Typography>
                );
              } else {
                return (
                  <Typography fontSize={"0.7rem"}>
                    User
                  </Typography>
                );
              }
            })()}
            {!memberData?.userInfo?.membership && (
              <>
                <Box
                  ml="0.4rem"
                  sx={{
                    height: "0.5rem",
                    width: "0.5rem",
                    borderRadius: "50%",
                    bgcolor: "red",
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                  }}
                />
                <img
                  onClick={() => {
                    onInfo();
                  }}
                  src={infoIcon}
                  alt="info"
                  style={{
                    height: "1rem",
                    width: "1rem",
                    marginLeft: "0.25rem",
                    cursor: "pointer",
                  }}
                />
              </>
            )}
          </Box>
        }
      />
      {buttonName !== "" && (
        <Button
          disabled={buttonDisabled}
          onClick={() => onTodo(memberData)}
          variant="outlined"
          sx={{
            backgroundColor: "#fff",
            borderRadius: "3px",
            padding: "0px 7px",
            textTransform: "none",
            color: "#183243",
            borderColor: "#183243",
            fontSize: fontSizeSchemes.font14,
            fontWeight: 400,
            ":hover": {
              color: "#183243",
              borderRadius: "3px",
              borderColor: "#183243",
            },
          }}
        >
          {buttonName}
        </Button>
      )}
    </Stack>
  );
});

const UserListDrawer = ({
  groupMemberData,
  internalMemebrData,
  externalMemberData,
  externalGroupRecipient,
  externalGroupMember,
  handleSelectCompanyAllRecipients,
  handleSelectExternalRecipients,
  handleClostRecipientsDrawer,
  handleSelectedRecipients,
  selectedRecipients,
  handleCLickTodo,
  isDisableAssignTaskBtn,
  taskModalDeatils,
  msgType,
  taskData,
  chatInputControl
}) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const { currentUserData, threadMsgList } = useAppSelectors();
  const [isAlertModalOpen, setAlertModalOpen] = useState(false);
  const isThreadScreen = session.get("isThreadScreen");
  // Looked up once per render instead of a scan per member.
  const selectedInternalIds = useMemo(
    () => new Set((selectedRecipients?.selectedInternalRecipients || []).filter(Boolean).map((item) => item?.userId)),
    [selectedRecipients?.selectedInternalRecipients],
  );
  const selectedExternalIds = useMemo(
    () => new Set((selectedRecipients?.selectedExternalRecipients || []).filter(Boolean).map((item) => item?.userId)),
    [selectedRecipients?.selectedExternalRecipients],
  );
  const threadParticipantIds = useMemo(() => new Set(threadMsgList?.[0]?.participants || []), [threadMsgList]);
  const taskParticipantIds = useMemo(() => new Set(taskData?.participants || []), [taskData?.participants]);
  const stable = useStableCallbacks({ handleSelectedRecipients, handleCLickTodo });
  const openAlert = useCallback(() => setAlertModalOpen(true), []);

  // A big group's members are built a part at a time as the list scrolls
  // (internal members, then external ones by company): building every row
  // at once took most of a second, and select all re-rendered them all.
  const internalMembers = groupMemberData?.internalMember || [];
  const externalRowCount = useMemo(
    () => externalMemberData.reduce((n, company) => n + (Object.values(company)[0]?.length || 0), 0),
    [externalMemberData],
  );
  const totalRows = internalMembers.length + externalRowCount;
  const [shownRows, listRef, moreRef] = useProgressiveList(totalRows);
  const visibleExternal = [];
  let externalBudget = shownRows - internalMembers.length;
  for (const company of externalMemberData) {
    if (externalBudget <= 0) break;
    const rows = (Object.values(company)[0] || []).slice(0, externalBudget);
    externalBudget -= rows.length;
    visibleExternal.push({ company, rows });
  }
  const hasTodoButton = taskModalDeatils?.buttonname !== "";

  const getDisableTaskApproveButton = (memberData, type) => {
    if (msgType === MessageType?.Approval) {
      if (type === "internal") {
        return memberData?.userId === currentUserData?.id
          ? true
          : !isDisableAssignTaskBtn;
      } else {
        return memberData?.userId === currentUserData?.id
          ? true
          : !isDisableAssignTaskBtn;
      }
    }
    return !isDisableAssignTaskBtn;
  };
  return (
    <React.Fragment>
      <AlertPopUp
        title={"Alert"}
        bodyContent={appContent?.KEY294}
        open={isAlertModalOpen}
        closeModal={setAlertModalOpen}
      />
      <Box sx={classes.drawerBody}>
        <Stack>
          <Stack
            direction="row"
            alignItems="center"
            spacing={2}
            sx={classes.header}
          >
            <Typography sx={classes.iconDiv}>
              <CloseIcon
                sx={classes.iconn}
                onClick={handleClostRecipientsDrawer}
              />
            </Typography>
            <Typography
              fontSize={fontSizeSchemes.font18}
              fontWeight={400}
              color={"black"}
            >
              {taskModalDeatils?.title}
            </Typography>
          </Stack>
          <Box
            ref={listRef}
            mt={"0.5rem"}
            overflow={"scroll"}
            height={"calc(100vh - 14rem)"}
            sx={{
              "&::-webkit-scrollbar": {
                width: "2px",
                padding: "0px 2px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#F9F8F8",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "grey",
              },
            }}
          >
            <Box padding="0px 19px 0px 12px">
              <Typography
                fontSize={fontSizeSchemes.font14}
                fontWeight={400}
                color={"black"}
              >
                {taskModalDeatils?.subHeader}
              </Typography>
            </Box>
            {internalMembers.length > 0 &&
              internalMembers.slice(0, shownRows).map((memberData, i) => (
                // A fragment, not a Box: a tick re-renders this list, and a
                // styled wrapper per member made that most of the work.
                <React.Fragment key={memberData.userId + "recipientList"}>
                  {i === 0 && (
                    <>
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={1}
                        padding="0px 19px 0px 12px"
                      >
                        <FormControlLabel
                          sx={{
                            ".MuiFormControlLabel-label": {
                              fontWeight: 500,
                              color: "#000000",
                            },
                          }}
                          control={
                            <Checkbox
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  fontSize: 30,
                                  color: "#183243",
                                },
                              }}
                              // disabled={
                              //   isThreadScreen &&
                              //   selectedRecipients?.selectedInternalRecipients
                              //     ?.length +
                              //     selectedRecipients?.selectedExternalRecipients
                              //       ?.length ===
                              //     internalMemebrData?.length +
                              //       externalGroupRecipient?.length
                              // }
                              checked={
                                selectedRecipients?.selectedInternalRecipients
                                  ?.length +
                                  selectedRecipients?.selectedExternalRecipients
                                    ?.length ===
                                internalMemebrData?.length +
                                  externalGroupRecipient?.length
                              }
                              onChange={(event) =>
                                handleSelectedRecipients(
                                  event,
                                  null,
                                  "AllMember",
                                )
                              }
                              checkedIcon={
                                <img
                                  style={checkboxIconStyle}
                                  src={SelectCheckBox}
                                  alt="selected"
                                />
                              }
                              icon={
                                <NameBadge
                                  sx={memberIndicatorStyle}
                                  size="small"
                                  variant="contained"
                                >
                                  <img src={PersonIcon} alt="all" />
                                  {/* <Typography
                                    color={"#183243"}
                                    fontSize={"0.75rem"}
                                    fontWeight={600}
                                  >
                                    A
                                  </Typography> */}
                                </NameBadge>
                              }
                            />
                          }
                          label={
                            <Typography
                              maxWidth={"25rem"}
                              overflow={"hidden"}
                              textOverflow={"ellipsis"}
                              whiteSpace={"nowrap"}
                              fontSize={fontSizeSchemes.font16}
                              fontWeight={500}
                            >
                              All Group Members
                            </Typography>
                          }
                        />
                      </Stack>

                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={1}
                        padding="0px 19px 0px 12px"
                      >
                        <FormControlLabel
                          sx={{
                            ".MuiFormControlLabel-label": {
                              fontWeight: 600,
                              color: "#000000",
                            },
                          }}
                          control={
                            <Checkbox
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  fontSize: 30,
                                  color: "#183243",
                                },
                              }}
                              // disabled={
                              //   isThreadScreen &&
                              //   (selectedRecipients?.selectedInternalRecipients
                              //     ?.length +
                              //     selectedRecipients?.selectedExternalRecipients
                              //       ?.length ===
                              //     internalMemebrData?.length +
                              //       externalGroupRecipient?.length ||
                              //     selectedRecipients
                              //       ?.selectedInternalRecipients?.length ===
                              //       internalMemebrData?.length)
                              // }
                              checked={
                                selectedRecipients?.selectedInternalRecipients
                                  ?.length === internalMemebrData?.length
                              }
                              onChange={(e) =>
                                handleSelectedRecipients(e, null, "MyTeam")
                              }
                              checkedIcon={
                                <img
                                  style={checkboxIconStyle}
                                  src={SelectCheckBox}
                                  alt="selected"
                                />
                              }
                              icon={
                                <NameBadge
                                  sx={memberIndicatorStyle}
                                  size="small"
                                  variant="contained"
                                >
                                  {/* <Typography
                                    color={"#183243"}
                                    fontSize={"0.75rem"}
                                    fontWeight={600}
                                  >
                                    {
                                      currentUserData?.activeSubscriber
                                        ?.subscriberFirmName[0]
                                    }
                                  </Typography> */}
                                  <img src={PersonIcon} alt="all" />
                                </NameBadge>
                              }
                            />
                          }
                          label={
                            <Typography
                              title={
                                currentUserData?.activeSubscriber
                                  ?.subscriberFirmName
                              }
                              maxWidth={"25rem"}
                              overflow={"hidden"}
                              textOverflow={"ellipsis"}
                              whiteSpace={"nowrap"}
                              fontSize={fontSizeSchemes.font16}
                              fontWeight={500}
                            >
                              My Team
                            </Typography>
                          }
                        />
                      </Stack>
                    </>
                  )}
                  {memberData?.permissionType !==
                    GroupLevelArkchatPermission?.REMOVE && (
                    <InternalMemberRow
                      memberData={memberData}
                      checked={selectedInternalIds.has(memberData.userId)}
                      disabled={
                        (isThreadScreen && threadParticipantIds.has(memberData.userId)) ||
                        taskParticipantIds.has(memberData.userId) ||
                        (memberData?.userId === currentUserData?.id &&
                          msgType === MessageType?.Approval)
                      }
                      isApprovalSelf={
                        memberData?.userId === currentUserData?.id &&
                        msgType === MessageType?.Approval
                      }
                      buttonName={taskModalDeatils?.buttonname}
                      // Unused without the button: constant, so the first tick
                      // doesn't re-render every row.
                      buttonDisabled={hasTodoButton ? getDisableTaskApproveButton(memberData, "internal") : true}
                      onToggle={stable.handleSelectedRecipients}
                      onTodo={stable.handleCLickTodo}
                      onInfo={openAlert}
                    />
                  )}
                </React.Fragment>
              ))}
            <Box>
              {visibleExternal.map(({ company, rows }, index) => (
                <Box key={index + "externalRecipientGroup"}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={1}
                    padding="0px 19px 0px 12px"
                  >
                    <FormControlLabel
                      sx={{
                        ".MuiFormControlLabel-label": {
                          fontWeight: 600,
                          color: "#000000",
                        },
                      }}
                      control={
                        <Checkbox
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: 30,
                              color: "#183243",
                            },
                          }}
                          // disabled={
                          //   isThreadScreen &&
                          //   (selectedRecipients?.selectedInternalRecipients
                          //     ?.length +
                          //     selectedRecipients?.selectedExternalRecipients
                          //       ?.length ===
                          //     internalMemebrData?.length +
                          //       externalGroupRecipient?.length ||
                          //     Object.values(company)[0]?.length ===
                          //       externalGroupMember[Object.keys(company)[0]]
                          //         ?.length)
                          // }
                          checked={
                            Object.values(company)[0]?.length ===
                            externalGroupMember[Object.keys(company)[0]]?.length
                          }
                          onChange={(event) =>
                            handleSelectCompanyAllRecipients(
                              event,
                              company,
                              Object.keys(company)[0],
                            )
                          }
                          checkedIcon={
                            <img
                              style={checkboxIconStyle}
                              src={SelectCheckBox}
                              alt="selected"
                            />
                          }
                          icon={
                            <NameBadge
                              sx={memberIndicatorStyle}
                              size="small"
                              variant="contained"
                            >
                              {/* <Typography
                                color={"#183243"}
                                fontSize={"0.75rem"}
                                fontWeight={600}
                              >
                                {Object.keys(company)[0] &&
                                  Object.keys(company)[0][0]}
                              </Typography> */}
                              <img src={PersonIcon} alt="all" />
                            </NameBadge>
                          }
                        />
                      }
                      label={
                        <Typography
                          title={Object.keys(company)[0]}
                          maxWidth={"25rem"}
                          overflow={"hidden"}
                          textOverflow={"ellipsis"}
                          whiteSpace={"nowrap"}
                          fontSize={"0.88rem"}
                          fontWeight={600}
                        >
                          {Object.keys(company)[0]}
                        </Typography>
                      }
                    />
                  </Stack>

                  {rows.map((item, i) => (
                    <Stack
                      key={i + "externalRecipientGroupCompany"}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      spacing={1}
                      padding={"0rem 0.7rem 0rem 2rem"}
                    >
                      <FormControlLabel
                        sx={{
                          ".MuiFormControlLabel-label": {
                            fontSize: "0.78rem !important",
                            color: "#000000",
                          },
                        }}
                        control={
                          <Checkbox
                            sx={{
                              "& .MuiSvgIcon-root": {
                                fontSize: 25,
                                color: "#183243",
                              },
                            }}
                            disabled={
                              (isThreadScreen && threadParticipantIds.has(item.userId)) ||
                              taskParticipantIds.has(item.userId)
                            }
                            onChange={(event) =>
                              handleSelectExternalRecipients(
                                event,
                                item,
                                Object.keys(company)[0],
                                Object.values(company)[0],
                              )
                            }
                            checked={selectedExternalIds.has(item?.userId)}
                            checkedIcon={
                              <img
                                style={checkboxIconStyle}
                                src={SelectCheckBox}
                                alt="selected"
                              />
                            }
                            icon={
                              <NameBadge
                                sx={memberIndicatorStyle}
                                size="small"
                                variant="contained"
                              >
                                <img src={PersonIcon} alt="all" />
                                {/* <Typography
                                  color={"#183243"}
                                  fontSize={"0.75rem"}
                                >
                                  {item?.firstName && item?.firstName[0]}
                                </Typography> */}
                              </NameBadge>
                            }
                          />
                        }
                        label={
                          <Box
                            display={"flex"}
                            alignItems={"center"}
                            gap={"0.15rem"}
                          >
                            <Typography
                              title={`${item?.firstName} ${item?.lastName}`}
                              maxWidth={"20rem"}
                              overflow={"hidden"}
                              textOverflow={"ellipsis"}
                              whiteSpace={"nowrap"}
                              fontSize={fontSizeSchemes.font14}
                              fontWeight={400}
                            >
                              {`${item?.firstName} ${item?.lastName}`}
                              <>,</>
                            </Typography>
                            {(() => {
                              if (
                                item?.accountPermission ===
                                AccountLevelArkchatPermission?.ADMIN
                              ) {
                                if (
                                  item?.inviteType ===
                                  InviteType?.ownerInviteType
                                ) {
                                  return (
                                    <Typography fontSize={"0.7rem"}>
                                      Owner
                                    </Typography>
                                  );
                                } else {
                                  return (
                                    <Typography fontSize={"0.7rem"}>
                                      Admin
                                    </Typography>
                                  );
                                }
                              } else {
                                return (
                                  <Typography fontSize={"0.7rem"}>
                                    User
                                  </Typography>
                                );
                              }
                            })()}
                            {/* {item?.accountPermission ===
                              AccountLevelArkchatPermission?.ADMIN &&
                              (item?.inviteType === InviteType?.ownerInviteType) && (
                                <Typography fontSize={"0.7rem"}>
                                  Owner
                                </Typography>
                              )}
                              {item?.accountPermission ===
                              AccountLevelArkchatPermission?.ADMIN &&
                              (item?.inviteType !== InviteType?.ownerInviteType) && (
                                <Typography fontSize={"0.7rem"}>
                                  Admin
                                </Typography>
                              )} */}
                            {!item?.membership && (
                              <>
                                <Box
                                  ml="0.4rem"
                                  sx={{
                                    height: "0.5rem",
                                    width: "0.5rem",
                                    borderRadius: "50%",
                                    bgcolor: "red",
                                  }}
                                />
                                <img
                                  src={infoIcon}
                                  alt="info"
                                  style={{
                                    height: "1rem",
                                    width: "1rem",
                                    marginLeft: "0.25rem",
                                    cursor: "pointer",
                                  }}
                                />
                              </>
                            )}
                          </Box>
                        }
                      />
                      {taskModalDeatils?.buttonname !== "" && (
                        <Button
                          disabled={getDisableTaskApproveButton(
                            item,
                            "external",
                          )}
                          onClick={() => handleCLickTodo(item, false)}
                          variant="outlined"
                          sx={{
                            backgroundColor: "#fff",
                            borderRadius: "3px",
                            padding: "0px 7px",
                            textTransform: "none",
                            color: "#183243",
                            borderColor: "#183243",
                            fontSize: fontSizeSchemes.font14,
                            fontWeight: 400,
                            ":hover": {
                              color: "#183243",
                              borderRadius: "3px",
                              borderColor: "#183243",
                            },
                          }}
                        >
                          {taskModalDeatils?.buttonname}
                        </Button>
                      )}
                    </Stack>
                  ))}
                </Box>
              ))}
            </Box>
            {shownRows < totalRows && <Box ref={moreRef} height="1px" />}
          </Box>
        </Stack>
      </Box>
      {(isThreadScreen&&taskModalDeatils?.msgType===MessageType?.Direct_Mesage) && <Box padding="0px 19px 0px 12px">{chatInputControl({ hideSuggestBtn: true })}</Box>}
    </React.Fragment>
  );
};

export default UserListDrawer;
